export const SEND_INVITATIONS = {
  title: 'Add team members',
  message: undefined,
  warning: '',
  subtitle: 'Invite members',
  button: 'Send Invitations',
  addAnotherButton: 'Add another',
};

export const INVITATIONS_SENT = {
  title: 'Invites sent',
  message: 'New members were invited to your team.',
  warning: '',
  subtitle: 'Invite sent to:',
  button: 'Invite More Members',
  addAnotherButton: undefined,
};

export const MODAL_DIMENSIONS = {
  width: '100%',
  height: '620px',
} as const;
